export default function Disclaimer({ compact = false }) {
    return (
        <div
            className={`${
                compact
                    ? "px-4 pb-4 pt-1 text-[11px]"
                    : "relative z-10 px-6 pt-24 pb-10 text-xs"
            } text-center text-rt-dim max-w-2xl mx-auto leading-relaxed`}
            data-testid="disclaimer"
        >
            RealTalk AI provides general guidance and perspective only. Not a
            substitute for professional, legal, or medical advice.
        </div>
    );
}
